import { useState } from "react";
import { useLocation } from "wouter";
import { textGradient, COLOR } from "../common/css/colors";

import { post } from "../common/net/requester";

import { A, Button, EmailEntry } from "../components";

const Login = () => {
    const [, setLocation] = useLocation();

    const [email, setEmail] = useState("");
    const [emailValid, setEmailValid] = useState(false);

    const loginInit = () => {
        post("/auth/login", { email })
            .then((res) => {
                if (!res.ok) {
                    console.log(res.status, res.message);
                    return;
                }

                const queryParams = new URLSearchParams({ email });

                setLocation("/verify?" + queryParams);
            })
            .catch((err) => {
                console.error("fail to login:", err);
            });
    };

    return (
        <div className="routeParent">
            <div className="routeInner">
                <a
                    className="signupQuestieHeader"
                    href="/"
                    style={{ textDecoration: "none" }}
                >
                    <h1
                        style={{
                            ...textGradient(COLOR.teal3, COLOR.lime3),
                            userSelect: "none",
                        }}
                    >
                        questie
                    </h1>
                </a>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1em",
                        border: "1px solid",
                        borderRadius: "4px",
                        padding: "2em",
                    }}
                >
                    <h3>Hello quest enjoyer, welcome back!</h3>

                    <EmailEntry
                        email={email}
                        setEmail={setEmail}
                        setEmailIsValid={setEmailValid}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "3em",
                        }}
                    >
                        <div>
                            No account? <A href={"/signup"} text={"Sign up"} />
                        </div>

                        <Button
                            text="Log in"
                            disabled={!emailValid}
                            onClick={loginInit}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
